//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
import "../no/Expression.js";
let d=[[[0,"Target",1,"DisplayableObject",0],[0,"TrimType",1,0],[1,"Value",0,"Expression",0]],[[["value_expression"],"SetValue",{},1,1],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.Extend = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.Extend";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.Extend.ExtendType = Object.freeze({
    "Value" : "Value", "ValueFromStartLimit" : "ValueFromStartLimit", "UntilNext" : "UntilNext", "UntilSelected" : "UntilSelected", "UntilExtended" : "UntilExtended", "OffsetFromSelected" : "OffsetFromSelected", "ThroughAll" : "ThroughAll", "Symmetric" : "Symmetric", "Percent" : "Percent", "ArcLength" : "ArcLength", "ThruPoint" : "ThruPoint"});

export default SPLM;